export default __webpack_public_path__ + "static/media/GuessJobs1_03.2df81dda.png";